<template>
    <el-container>
        <div style="width: 200px;background-color: #222f3e">
            <el-aside :width="isCollapse?'60px':'200px'">
                <el-col :gutter="20">
                    <el-row :span="4">
                        <div class="logo">
                            <img   style="width: 60px" class="icon" src="../assets/logo2.jpg">
                            <div class="sys-name" >{{$t('common.title')}}</div>
                        </div>
                    </el-row>
                    <el-row :span="20">
                        <el-menu :default-active="activePath" class="el-menu-vertical-demo"
                                 background-color="#222f3e" text-color="#fff" active-text-color="#ffd04b"
                                 :collapse="isCollapse" :unique-opened="true"
                                 :collapse-transition="false" :router="true">
                            <!--一级菜单-->
                            <el-submenu :index="item.applicationUuid.toString()" v-for="item in menuList" :key="item.applicationUuid">
                                <!--一级菜单模板区域-->
                                <template slot="title">
                                    <!--图标-->
                                    <i :class="item.applicationIcon"></i>
                                    <!--文本-->
                                    <span v-if="show">{{item.applicationName}}</span>
                                    <span v-else>{{item.applicationDesc}}</span>
                                </template>
                                <!--二级菜单-->
                                <el-menu-item :index="'/'+menu.functionRouter"
                                              v-for="menu in item.functions" :key="menu.functionUuid"
                                              @click="saveNavState('/'+menu.functionRouter)">
                                    <template slot="title">
                                        <!--图标-->
                                        <i :class="menu.functionIcon"></i>
                                        <!--文本-->
                                        <span v-if="show">{{menu.functionName}}</span>
                                        <span v-else>{{menu.functionDesc}}</span>
                                    </template>
                                </el-menu-item>
                            </el-submenu>
                        </el-menu>
                    </el-row>
                </el-col>
            </el-aside>
        </div>
        <el-container>
            <el-header>
                <el-menu :default-active="activePath1" class="el-menu-demo" mode="horizontal"
                         background-color="#576574" text-color="#fff" active-text-color="#ffd04b">
                    <el-popover
                            v-show="type=='userT'"
                            placement="right"
                            width="220"
                            trigger="click">
                        <div style="float: left">
                            <div class="qrcode" ref="qrCodeUrl" >

                            </div>
                            <div class="qrcode1"  @click="xzApp">
                                {{$t('common.app')}}
                            </div>
                        </div>
                        <!--<div style="float: left;margin-left: 40px">-->
                            <!--<div class="qrcode" ref="qrCodeUrl1" >-->

                            <!--</div>-->
                            <!--<div class="qrcode1"  @click="xzApp1">-->
                                <!--点击下载路面检测APP-->
                            <!--</div>-->
                        <!--</div>-->
                        <el-button style="margin-right: 10px" size="mini" slot="reference">{{$t('common.smxz')}}</el-button>
                        <el-button style="margin-right: 10px" size="mini" slot="reference" @click="language">{{languageName}}</el-button>
                    </el-popover>
                    <a style="color: white">{{username}}</a>
                    <el-submenu index="1" class="user-icon">
                        <template slot="title">
                            <el-avatar src="https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png">
                            </el-avatar>
                        </template>
                        <el-menu-item index="1-1" @click="logout">{{$t('common.logout')}}</el-menu-item>
                    </el-submenu>
                </el-menu>
            </el-header>
            <el-main>
                <router-view/>
            </el-main>
        </el-container>
    </el-container>
</template>

<script>
    import QRCode from 'qrcodejs2'
    export default {
        name: "Home",
        data() {
            return {
                show:true,
                languageName:localStorage.getItem("languageName")?localStorage.getItem("languageName"):'中文',
                appUrl1:'',
                showadd:true,
                appUrl:'',
                menuList: [],
                isCollapse: false,
                username:window.sessionStorage.getItem('username'),
                type:window.sessionStorage.getItem('type'),
                activePath: '',
                activePath1: '',
                menuListForm: {
                    pageSize: 1,
                    pageNum: -1
                }
            }
        },
        async created() {
            this.showadd=true
            // let {data: res} = await this.$http.post('/api/menuList/selectList', this.menuListForm);
            this.menuListForm.roleId = window.sessionStorage.getItem("RoleId");
            let {data: res} = await this.$http.post('/api/menuInfo/getMenuByUserId', this.menuListForm);
            if (res.code !== 1) {
                this.$message.error(res.msg)
            } else {
                this.menuList = res.data
            }
            if(localStorage.getItem('system_key')=='en'){
                localStorage.setItem("system_key","en")
                localStorage.setItem("languageName","英文")
                this.$i18n.locale = "en"
                this.languageName="英文"
                this.show=false
            }else{
                localStorage.setItem("system_key","zh")
                this.$i18n.locale = "zh"
                localStorage.setItem("languageName","中文")
                this.languageName="中文"
                this.show=true
            }
            // 记录上一次激活的菜单
            this.activePath = window.sessionStorage.getItem('activePath')
            this.getappUrl()
            this.getappUrl1()
        },
        destroyed(){
        },
        methods: {
            language(){
                if(localStorage.getItem('system_key')=='en'){
                    localStorage.setItem("system_key","zh")
                    this.$i18n.locale = "zh"
                    localStorage.setItem("languageName","中文")
                    this.languageName="中文"
                    this.show=true
                }else{
                    localStorage.setItem("system_key","en")
                    localStorage.setItem("languageName","英文")
                    this.$i18n.locale = "en"
                    this.languageName="英文"
                    this.show=false
                }
            },
            xzApp(){
                window.location.href=this.appUrl
            },
            xzApp1(){
                window.location.href=this.appUrl1
            },
            async getappUrl(){
                const {data: res} = await this.$http.post(`/appedition/selectUpTimeT`, {});

                this.appUrl = res.data.versionsUrl
                this.creatQrCode();
            },
            async getappUrl1(){
                // const {data: res} = await this.$http.post(`/appedition/selectUpTimeJ`, {});
                //
                // this.appUrl1 = res.data.versionsUrl
                // this.creatQrCode1();
            },
            // 生成糖份二维码
            creatQrCode() {
                var qrcode = new QRCode(this.$refs.qrCodeUrl, {
                    text: this.appUrl, // 需要转换为二维码的内容
                    width: 200,
                    height: 200,
                    colorDark: "#000000",//二维码颜色
                    colorLight: "#ffffff",//二维码的背景色
                    correctLevel: QRCode.CorrectLevel.H//容错率，L/M/H
                });
            },
            // 生成路面检测二维码
            creatQrCode1() {
                var qrcode = new QRCode(this.$refs.qrCodeUrl1, {
                    text: this.appUrl1, // 需要转换为二维码的内容
                    width: 200,
                    height: 200,
                    colorDark: "#000000",//二维码颜色
                    colorLight: "#ffffff",//二维码的背景色
                    correctLevel: QRCode.CorrectLevel.H//容错率，L/M/H
                });
            },
            logout: function () {
                window.sessionStorage.clear();
                this.$router.push('/login')
            },
            toggleCollapse: function () {
                this.isCollapse = !this.isCollapse
            },
            saveNavState: function (activePath) {
                this.showadd=false
                window.sessionStorage.setItem('activePath', activePath)
            }
        }
    }
</script>

<style scoped lang="less">

    .el-aside {
        height: 100vh;
        background-color: #222f3e;
        line-height: 200px;
    }

    .el-menu-vertical-demo:not(.el-menu--collapse) {
        width: 200px;
        min-height: 400px;
    }

    .el-menu-demo {
        display: flex;
        width: 100%;
        height: 100%;
        justify-content: flex-end;
        align-items: center;

    }

    .el-menu-vertical-demo {
        border: 0;
    }

    .logo {
        background-color: #222f3e;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 60px;

        .sys-name {
            font-size: 16px;
            color: #ffffff;
            margin-left: 10px;

        }
    }

    .el-header {
        padding: 0;
        background-color: #576574;
    }

    .qrcode{
        height: 200px;
        width: 200px;
        /*border: 1px solid #eee;*/
        /*border-radius: 50%;*/
        /*padding: 10px;*/
        /*box-shadow: 0 0 10px #ddd;*/
    }
    .qrcode1{
        cursor:pointer;
        height: 10px;
        width: 200px;
        text-align: center;
        margin-top: 10px;
        /*border: 1px solid #eee;*/
        /*border-radius: 50%;*/
        /*padding: 10px;*/
        /*box-shadow: 0 0 10px #ddd;*/
    }
</style>
